// viewPagination.js

export const VIEW_PAGINATION = {
  LIST: {
    INITIAL: 100,
    STEP: 100,
  },
  GALLERY: {
    INITIAL: 40,
    STEP: 40,
  },
  TABLE: {
    INITIAL: 100,
    STEP: 100,
  },
};
